"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _modal = _interopRequireDefault(require("./modal.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Add div to the body where we will render the confirm modal
var elementId = 'cccisd-confirm';
var wrapper = document.getElementById(elementId);

if (!wrapper) {
  wrapper = document.createElement('div');
  wrapper.setAttribute('id', elementId);
  document.body.appendChild(wrapper);
}
/** cccisd-confirm provides you with confirmation window styled using bootstrap, like the Javascript confirm() functon */


var _default = function _default(options) {
  if (typeof options === 'string' || _react.default.isValidElement(options)) {
    options = {
      message: options
    };
  }

  var cleanup = function cleanup() {
    _reactDom.default.unmountComponentAtNode(wrapper);
  };

  var promise = {
    onResolve: cleanup,
    onReject: cleanup,
    then: function then(callback) {
      this.onResolve = function () {
        cleanup();
        callback();
      };

      return this;
    },
    fail: function fail(callback) {
      this.onReject = function () {
        cleanup();
        callback();
      };

      return this;
    }
  };

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_modal.default, _extends({}, options, {
    promise: promise
  })), wrapper);

  return promise;
};

exports.default = _default;